import { ModuleCode } from '@horevia/contracts';
import { Button, ComingSoonState, Container, PageHeader } from '@horevia/ui';
import { Link, createFileRoute } from '@tanstack/react-router';
import { Blocks } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { useCan } from '@/features/auth/session';

/** Page affichée quand une route appartient à un module non activé (ADR-014). */
export const Route = createFileRoute('/_app/module-unavailable')({
  validateSearch: z.object({ module: ModuleCode.optional() }),
  component: ModuleUnavailablePage,
});

function ModuleUnavailablePage() {
  const { t } = useTranslation(['common', 'settings']);
  const { module } = Route.useSearch();
  const canManage = useCan('module.read');
  const moduleName = module ? t(`settings:modules.names.${module}`) : '';
  return (
    <Container>
      <PageHeader
        title={t('common:states.moduleUnavailableTitle')}
        subtitle={t('common:states.moduleUnavailableDescription', { module: moduleName })}
      />
      <ComingSoonState
        icon={<Blocks className="ico ico-32" aria-hidden="true" />}
        title={t('common:states.moduleUnavailableTitle')}
        description={t('common:states.moduleUnavailableDescription', { module: moduleName })}
        action={
          <Button asChild variant="secondary">
            {canManage ? (
              <Link to="/admin/settings">{t('settings:modules.goToSettings')}</Link>
            ) : (
              <Link to="/">{t('common:actions.back')}</Link>
            )}
          </Button>
        }
      />
    </Container>
  );
}
